/**
 * Error functions is this file are largely take from this article:
 * https://medium.com/with-orus/the-5-commandments-of-clean-error-handling-in-typescript-93a9cbdf1af5
 */

/**
 * Takes anything and makes sure it is parsed as a JS Error
 */
export function ensureError(value: unknown): Error {
  if (value instanceof Error) return value;
  if (typeof value === 'string') return new Error(value);

  let stringified = '[Unable to stringify the thrown value]';
  try {
    stringified = JSON.stringify(value);
  } catch {
    // ignore
    console.log('Unable to stringify the thrown value:', value);
  }

  // Just return the stringified value as an error
  return new Error(stringified);
}

type Jsonable =
  | string
  | number
  | boolean
  | null
  | undefined
  | readonly Jsonable[]
  | { readonly [key: string]: Jsonable }
  | { toJSON(): Jsonable };

/**
 *
 */
export class BaseError extends Error {
  public readonly context?: Jsonable;

  constructor(
    message: string,
    options: { cause?: Error; context?: Jsonable } = {}
  ) {
    const { cause, context } = options;

    // Don't worry about this error.
    super(message, { cause });
    this.name = this.constructor.name;

    this.context = context;
  }
}
